// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loading_loader__zeSUs","load3":"Loading_load3__1mcXI"};